//import { css } from "@emotion/react";
import styled from "@emotion/styled/macro";
import { css } from "@mui/system";

export const ItemBox = styled.div(
  css({
    fontSize: "base",
    fontWeight: "bold",
    padding: "15px 25px",
    borderBottom: `2px solid`,
    borderBottomColor: "#F7F7F7",
  }),
  {
    display: "flex",
    alignItems: "center",
  }
);
export const Information = styled.div({
  display: "flex",
  flexDirection: "column",
  marginLeft: "15px",
});
export const Image = styled.img({
  maxWidth: 60,
  maxHeight: 60,
  objectFit: "cover",
  margin: "0 15px",
});
export const Name = styled.span(
  css({
    fontWeight: 500,
    color: "#0D1136",
    marginBottom: "0px",
    lineHeight: 1.5,
  })
);
export const Price = styled.span(
  css({
    color: "#009E7F",
    marginTop: "10px",
    marginBottom: "10px",
  })
);
export const Weight = styled.span(
  css({
    fontSize: "small",
    fontWeight: 400,
    color: "#77798C",
    marginBottom: "5px",
  })
);
export const Total = styled.span(
  css({
    color: "#0D1136",
    marginLeft: "auto",
  })
);

export const RemoveButton = styled.button({
  padding: "5px",
  border: 0,
  outline: 0,
  marginLeft: "15px",
  cursor: "pointer",
  color: "rgba(0, 0, 0, 0.25)",
  transition: "all 0.4s ease",
  backgroundColor: "transparent",

  "&:hover": {
    color: "red",
  },
});
